import { Box, Button, Tooltip, TextField } from '@mui/material';
import React, { Component } from 'react'
import { DeletePopup } from './CommonComponents';
import { ImagePaths } from '../../Utility/ImagePaths';
import { SketchField, Tools } from 'react-sketch-draw';
import { Colors } from '../../Styles/Colors';
import CreateIcon from '@material-ui/icons/Create';
import LineIcon from '@material-ui/icons/BorderColor';
import RectIcon from '@material-ui/icons/CropLandscape';
import CircleIcon from '@material-ui/icons/RadioButtonUnchecked';
import AddIcon from '@material-ui/icons/AddOutlined';
import SprayIcon from '@material-ui/icons/BlurCircular';
import UndoIcon from '@material-ui/icons/UndoOutlined';
import RedoIcon from '@material-ui/icons/RedoOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import SaveIcon from '@material-ui/icons/Save';

const colorButtons = [
    { color: '#000000', image: ImagePaths.Black.default, color_name: 'black' },
    { color: '#F19C38', image: ImagePaths.Orange.default, color_name: 'orange' },
    { color: '#4A95EC', image: ImagePaths.Blue.default, color_name: 'blue' },
    { color: '#67AC5B', image: ImagePaths.Green.default, color_name: 'green' },
    { color: '#E15241', image: ImagePaths.Red.default, color_name: 'red' },
    { color: '#74574A', image: ImagePaths.Brown.default, color_name: 'brown' },
    { color: '#FFFFFF', image: ImagePaths.White.default, color_name: 'white' },
];

const toolButtons = [
    { title: 'Spray', icon: <SprayIcon />, tool: Tools.Spray, lineWidth: 10 },
    { title: 'Pencil', icon: <CreateIcon />, tool: Tools.Pencil, lineWidth: 3 },
    { title: 'Line Pencil', icon: <LineIcon />, tool: Tools.Line, lineWidth: 3 },
    { title: 'Rectangle', icon: <RectIcon />, tool: Tools.Rectangle, lineWidth: 3 },
    { title: 'Circle', icon: <CircleIcon />, tool: Tools.Circle, lineWidth: 3 },
];

const styles = {
    control: {
        width: "24px",
        height: "24px",
    },
    control_space_1: {
        width: "24px",
    },
}

export default class SketchDiagram extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lineColor: '#000000',
            tool: Tools.Pencil,
            lineWidth: 3,
            canUndo: false,
            canRedo: false,
            text: '',
            defaultImage: this.props.defaultImage,
            fillColor: Colors.red,
            fillWithColor: false,
            fillWithBackgroundColor: false,
            backgroundColor: '#FFF',
            controlledValue: null,
            background: null
        }
    }

    componentDidMount() {
        this.setState({ background: this.props.image }, () => {
            this._sketch.setBackgroundFromDataUrl(this.state.background)
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({ background: this.props.image }, () => {
                this._sketch.setBackgroundFromDataUrl(this.state.background)
            })
        }
    }

    _onSketchChange = () => {
        let prev = this.state.canUndo;
        let now = this._sketch.canUndo();
        if (prev !== now) {
            this.setState({ canUndo: now });
        }
    };

    _changeColor = (color) => {
        let { tool } = this.state;

        this.setState({
            lineColor: color,
            tool: Tools.Pan
        }, () => {
            this.setState({ tool: tool });
        });
    };

    _undo = () => {
        this._sketch.undo();
        this.setState({
            canUndo: this._sketch.canUndo(),
            canRedo: this._sketch.canRedo(),
        });
    };

    _redo = () => {
        this._sketch.redo();
        this.setState({
            canUndo: this._sketch.canUndo(),
            canRedo: this._sketch.canRedo(),
        });
    };

    _addText = () => {
        this.setState({ tool: Tools.Select });
        this._sketch.addText(this.state.text);
    };


    _clear = () => {
        this._sketch.clear();
        this._sketch.setBackgroundFromDataUrl(this.state.defaultImage);
        this.setState({
            controlledValue: null,
            backgroundColor: "#FFF",
            fillWithBackgroundColor: false,
            canUndo: this._sketch.canUndo(),
            canRedo: this._sketch.canRedo(),
            isDeleteCliked: false
        }, () => {
            if (this.props.onDelete) {
                this.props.onDelete(this.state.defaultImage)
            }
        });
    };

    _save = () => {
        const dataUrl = this._sketch.toDataURL();
        if (this.props.onSave) {
            this.props.onSave(dataUrl)
        }
    }

    popupClose = () => {
        this.setState({ isDeleteCliked: false })
    }

    render() {
        let { controlledValue } = this.state;
        return (
            <Box>
                <Box height="50dvh" display="flex" alignItems="center" justifyContent="center">
                    <Box component={'div'} border={'1px solid lightgray'}>
                        <SketchField
                            name="sketchfield"
                            ref={(c) => (this._sketch = c)}
                            tool={this.state.tool}
                            lineColor={this.state.lineColor}
                            lineWidth={this.state.lineWidth}
                            fillColor={this.state.fillWithColor ? this.state.fillColor : "transparent"}
                            backgroundColor={this.state.fillWithBackgroundColor ? this.state.backgroundColor : "transparent"}
                            width={700}
                            height={300}
                            undoSteps={2000}
                            value={controlledValue}
                            forceValue
                            onChange={this._onSketchChange}
                        />
                    </Box>
                </Box>
                <Box height="15dvh">
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ backgroundColor: Colors.Background }}>
                        <Box>
                            {colorButtons.map((item, index) => (
                                <Button className='Common_Btn_Min_Width' emed_tid={item.color}
                                    key={index}
                                    onClick={() => this._changeColor(item.color)}
                                    sx={{
                                        border: this.state.lineColor === item.color ? '1px solid #04B7B1' : null,
                                        borderRadius: '100px',
                                    }}
                                >
                                    <Box component="img" src={item.image} height="1.5vw" width="1.5vw" />
                                </Button>
                            ))}
                        </Box>
                        <Box ml="5rem">
                            {toolButtons.map((item, index) => (
                                <Tooltip key={index} title={item.title} placement="top">
                                    <Button className='Common_Btn_Min_Width' emed_tid={item.tool}
                                        sx={{
                                            borderRadius: '100px', ml: '1rem', border: this.state.tool === item.tool ? '1px solid #04B7B1' : null,
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                tool: item.tool,
                                                lineWidth: item.lineWidth,
                                            }, () => { this._changeColor("#000000") });
                                        }}
                                    >
                                        {item.icon}
                                    </Button>
                                </Tooltip>
                            ))}
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Tooltip title="Eraser" placement="top">
                            <Button emed_tid='eraser'
                                onClick={() => {
                                    this.setState({
                                        tool: Tools.Pencil,
                                        lineWidth: 10,
                                    }, () => { this._changeColor("#FFFFFF") });
                                }}
                            >
                                <Box component="img" src={ImagePaths.Eraser.default} height="1.2vw" width="1.2vw" />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Undo" placement="top">
                            <Button color="primary" emed_tid='undo'
                                disabled={!this.state.canUndo}
                                onClick={() => { this._undo() }}>
                                <UndoIcon style={styles.control} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Redo" placement="top">
                            <Button color="primary" emed_tid='redo'
                                disabled={!this.state.canRedo}
                                onClick={() => { this._redo() }}>
                                <RedoIcon style={styles.control} />
                            </Button>
                        </Tooltip>
                        <TextField emed_tid='txt'
                            variant="standard"
                            value={this.state.text}
                            onChange={(e) => { this.setState({ text: e.target.value }) }}
                            placeholder="Enter text"
                        />
                        <Tooltip title="Add Text" placement="top">
                            <Button color="primary" emed_tid='add' onClick={() => { this._addText() }}>
                                <AddIcon style={styles.control} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Save" placement="top">
                            <Button emed_tid='save' onClick={() => { this._save() }}>
                                <SaveIcon style={styles.control} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Trash" placement="top">
                            <Button emed_tid='dlt' color="primary" onClick={() => { this.setState({ isDeleteCliked: true }) }}>
                                <DeleteIcon style={styles.control} />
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>
                {this.state.isDeleteCliked ? <DeletePopup
                    DeletTitle={"Are you sure you want to delete Fundus ?"}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this._clear.bind(this)}
                /> : null}
            </Box>
        )
    }
}
